(function () {
    "use strict";

    angular
        .module("app")
        .factory("HierarchyService", hierarchyService);


    hierarchyService.$inject =
        ["WebApiService"];

    function hierarchyService(webApiService) {
        return {
            getHierarchyTreeModel: function (linePlanId, briefSeasonalId, patternSeasonalId, prototypeSeasonalId) {
                return webApiService.get("/api/Hierarchy/GetHierarchyTreeModel?linePlanId=" + linePlanId + "&briefSeasonalId=" + briefSeasonalId + "&patternSeasonalId=" + patternSeasonalId + "&prototypeSeasonalId=" + prototypeSeasonalId)
            }
        };
    }
})();
